import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router'; // import router from angular router
import { GlobalConstants } from '../app.component';
import { APIService } from '../common/api.component';
import { SharedService } from '../common/shared.service';
import { Utils } from '../common/utils.component';
import { Constants } from '../common/constants';

@Component({
  selector: 'app-login-page',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public IsCheckedAuthentication: boolean = false;
  mode: any;
  isUpload: any;
  loading: boolean = true;
  InstanceTitle: string = Constants.InstanceTitle;
  InstanceInfo: string = Constants.InstanceInfo;
  LoginPart1Heading: string = Constants.LoginPart1Heading;
  LoginPart1Information: string = Constants.LoginPart1Information;
  LoginPart2Heading: string = Constants.LoginPart2Heading;
  LoginPart2Information: string = Constants.LoginPart2Information;
  LoginInfoTap: string = Constants.LoginInfoTap;
  LoginInfoTapEnd: string = Constants.LoginInfoTapEnd;
  LoginGetStartedButtonText: string = Constants.LoginGetStartedButtonText;
  LoginKBNoteText: string = Constants.LoginKBNoteText;
  LoginKBNoteLinkText: string = Constants.LoginKBNoteLinkText;
  KnowledgebaseLink: string = Constants.KNOWLEDGEBASELINK;
  HighQDemoText: string = Constants.HIGHQDEMOTEXT;
  HighQDemoLinkText: string = Constants.HIGHQDEMOLINKTEXT;  
  HighQDemoTextEnd:string=Constants.HIGHQDEMOTEXTEND;
  HighQDemoLink:string=Constants.HIGHQDEMOLINK;
  errorMsg = ""

  constructor(
    private route: Router,
    private apiService: APIService,
    private sharedService: SharedService,
    private utils: Utils,
    private dialog: MatDialog,
    private renderer: Renderer2
  ) {
  }
  ngOnInit() {
    this.mode = this.apiService.GetMode();
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedService);
    if (String(this.mode) == 'null')
      this.isUpload = this.sharedService.isUploadFlow$.getValue() || {};
  }

  
   
   ngAfterViewInit() {
     //var width = this.scrollheight.nativeElement.offsetWidth;
     var height = this.scrollheight.nativeElement.offsetHeight;
      //this.fixheight.nativeElement,"padding-bottom","106px"
      this.renderer.setStyle(this.fixheight.nativeElement, "padding-bottom", height+"px");
   }
   
   @ViewChild('scrollheight')
   scrollheight: ElementRef;

   @ViewChild('fixheight')
   fixheight: ElementRef;
 


  ngAfterViewChecked() {
    if (String(GlobalConstants.Tid).length > 0) {
      this.apiService.setTheme();
      if (this.IsCheckedAuthentication)
        return;
      this.IsCheckedAuthentication = true;
      this.AuthenticateUser(false);
    }
  }

  public SetControlVisibility(Control, Visibility) {
    (<HTMLInputElement>document.getElementById(Control)).style.visibility = Visibility;
  }

  public AuthenticateUser(RedirectPage) {
    this.apiService.authenticateUserCall()
      .subscribe({next: data => {
        if (data['Key'] == "Authenticate" && data['Value'].length > 0) {
          GlobalConstants.Jwi = data['Value'];
          this.sharedService.login();
          if (String(this.mode) == 'null' && this.isUpload)
            this.apiService.RedirectPageBasedOnMode(this.sharedService, '3');
          else
            this.apiService.RedirectPageBasedOnMode(this.sharedService, this.mode);
        }
        else if (RedirectPage)
          window.location.replace(window.location.origin);
        else {
          this.loading = false;
          this.SetControlVisibility('divLogin', 'visible');
        }
      }, error: err => {
        this.utils.openConfirmationDialog({ errorData: err }, this.dialog, item => {
          this.apiService.logoutUser().subscribe(data => {
            this.sharedService.logout()
          })

        })
      }});
  }
  getTabType(arg0: any): any {
    switch (arg0) {
      case 'Browse':
        return 2
      case 'Favourite':
        return 1
      default:
        return 0
    }
  }

  getTabBaseUrl(arg0: any): any {
    switch (arg0) {
      case 'Browse':
        return '/sites'
      case 'Favourite':
        return '/favourite'
      default:
        return '/recent'
    }
  }

  public btnGetStartedClick() {
    this.route.navigate(['/instance']);
  }
}
